// ── Service de Reuniões (núcleo/aplicação) ────────────────────────
// CRUD de reuniões (tabela meetings). Recebe o repositório via porta (DI) —
// não conhece Supabase. Wiring concreto em src/app/agenda.ts.

import type { MeetingEntry } from '@/types/meeting';
import type { IMeetingRepository, CreateMeetingParams, MeetingDbStatus } from '../ports/IMeetingRepository';

export type { MeetingDbStatus, CreateMeetingParams } from '../ports/IMeetingRepository';

export interface MeetingStatusMeta {
  key: string;
  label: string;
  color: string;
}

// Metadados de status (puro — sem I/O).
export const MEETING_STATUS: MeetingStatusMeta[] = [
  { key: 'scheduled', label: 'Agendada',       color: '#2563C8' },
  { key: 'done',      label: 'Realizada',      color: '#166534' },
  { key: 'no_show',   label: 'Nao compareceu', color: '#DC2626' },
  { key: 'cancelled', label: 'Cancelada',      color: '#6B7280' },
];

export const getMeetingStatusMeta = (status: string): MeetingStatusMeta =>
  MEETING_STATUS.find(s => s.key === status) || MEETING_STATUS[0];

export class MeetingService {
  constructor(private readonly repo: IMeetingRepository) {}

  listMeetingsByLead = async (leadId: string | null | undefined): Promise<MeetingEntry[]> => {
    if (!leadId) return [];
    return this.repo.listMeetingsByLead(leadId);
  };

  createMeeting = (params: CreateMeetingParams): Promise<MeetingEntry> => {
    if (!params.workspaceId) throw new Error('workspaceId obrigatorio.');
    if (!params.leadId)      throw new Error('leadId obrigatorio.');
    if (!params.scheduledAt) throw new Error('scheduledAt obrigatorio.');
    return this.repo.createMeeting(params);
  };

  updateMeetingResult = (
    id: string,
    opts: { status: MeetingDbStatus; result?: string | null },
  ): Promise<MeetingEntry> => {
    return this.repo.updateMeetingResult(id, opts);
  };

  cancelMeeting = (id: string): Promise<MeetingEntry> => {
    return this.repo.updateMeetingResult(id, { status: 'cancelled' });
  };
}
